import styled from 'styled-components';
import { tokens } from '../../public/tokens';
import { MOBILE_MEDIA_QUERY } from '../library/breakpoints';

const { colors, effects, globals, typography } = tokens;

const DRAWER_WIDTH = '350px';

export const NotificationDrawer = styled.div(({ $isOpen }) => ({
    position: 'absolute',
    zIndex: 1,
    width: '100%',
    maxWidth: DRAWER_WIDTH,
    minHeight: 'calc(100% - 48px)',
    backgroundColor: colors.neutral.white,
    borderRight: `1px solid ${colors.surfaces['border-divider']}`,
    boxShadow: effects.effects.shadow.drawer,

    [MOBILE_MEDIA_QUERY]: {
        left: 0,
        maxWidth: '290px',
        boxShadow: effects.effects.shadow.default,
        transform: $isOpen ? 'none' : 'translateX(-100%)',
    },
}));

export const DrawerToggleButton = styled.button(({ $isOpen }) => ({
    display: 'none',
    position: 'absolute',
    top: $isOpen ? globals['spacing-3'] : '25px',
    right: $isOpen ? globals['spacing-md'] : '-40px',
    zIndex: 9,
    padding: 0,
    background: 'none',
    border: 'none',
    fontSize: typography.fontSize['xl-18px'],
    lineHeight: 1,
    color: colors.text.primary,

    [MOBILE_MEDIA_QUERY]: {
        display: 'block',
    },
}));

export const NotificationContent = styled.div({
    position: 'relative',
    left: DRAWER_WIDTH,
    width: '100%',
    maxWidth: `calc(100% - ${DRAWER_WIDTH})`,
    minHeight: '100%',
    padding: globals['spacing-8'],

    [MOBILE_MEDIA_QUERY]: {
        left: 0,
        maxWidth: '100%',
        padding: globals['spacing-lg'],
        paddingLeft: globals['spacing-12'],
    },
});
